import { AUTH_USER_SUCCESS, LOGOUT_USER, SET_USER_FORM, SET_PROJECT_DETAILS, CLEAR_STATE } from './types'

const userDataState = {
    name: '',
    email: '',
    role: '',
    phone: '',
    isAuthenticated: false,
    form: {
        contact_name: '',
        contact_phone: '',
        contact_cep: '',
        contact_email: '',
        project_rooms: [],
        material: '',
        details: '',
        has_project: null,
        project_time: null,
    }
}

const userDataReducer = (state, actions) => {
    const { type, payload } = actions

    switch (type) {
        case AUTH_USER_SUCCESS: {
            return {
                ...state,
                name: payload.name,
                email: payload.email,
                phone: payload.phone,
                role: payload.role,
                isAuthenticated: true
            }
        }
        case LOGOUT_USER: {
            return userDataState
        }
        case SET_USER_FORM: {
            return {
                ...state,
                form: {
                    ...payload,
                }
            }
        }
        case SET_PROJECT_DETAILS: {
            return {
                ...state,
                form: {
                    ...state.form,
                    details: payload
                }
            }
        }
        case CLEAR_STATE: {
            return {
                ...state,
                form: {
                    contact_name: '',
                    contact_phone: '',
                    contact_cep: '',
                    contact_email: '',
                    project_rooms: [],
                    material: '',
                    details: ''
                }
            }
        }
        default: {
          return state
        }
    }
}

export { userDataReducer as default, userDataState }